import React from 'react';
import './index.less';
import Memre from '../img/memre.jpg';

function Header() {
  return (
    <header className="header">
        <div className="mask"></div>
        <img className="header-img" src={Memre} alt="memre"></img>
        <h1 className="header-name">M.Emre Kılıç</h1> 
        <h2 className="header-title">Frontend Developer</h2>
    </header>
  );
}

export default Header;
